import useLastAcknowledgedActivityKey from '../providers/ActivityAcknowledgement/useLastAcknowledgedActivityKey';

export default useLastAcknowledgedActivityKey;
